export const POWERS_ORIGINS = {
  author: { id: "grow.about.author", defaultMessage: "Dr. Bernhard Zünkeler" },
  authorName: { id: "grow.about.authorName", defaultMessage: "Bernhard Zünkeler" },
};

export const POWERS_BOOKS = [
  { title: { id: "grow.about.book.atlas", defaultMessage: "Juicy Gray – Atlas der Kreativität" } },
  {
    title: { id: "grow.about.book.innovation", defaultMessage: "Innovationskraft in Unternehmen – Impulse für mehr Innovationsfähigkeit, Performanz und Zukunftsfähigkeit" },
    credit: { id: "grow.about.coAuthor", defaultMessage: "co-author" },
  },
  {
    title: { id: "grow.about.book.newWork", defaultMessage: "New Work: Auf dem Weg zur neuen Arbeitswelt – Management-Impulse, Praxisbeispiele, Studien" },
    credit: { id: "grow.about.contributor", defaultMessage: "contributor" },
  },
];
